import axios from 'axios'
import triplaLocalStorage from 'Utilities/triplaLocalStorage'
import { mapBrowserLocale } from 'Utilities'
import Url from 'url-parse'
import { getSession, removeSession } from 'Utilities/Session'
import { EventBus } from 'ChatWidget/EventBus'
import { isWebView, appAccessInfo } from 'Utilities/appAccess'
import { useChatStore } from 'Store/chat'
import { v4 as uuid } from 'uuid'
import { getTier } from 'Utilities/tier-manager'

const url = new Url(window.location, '/', true)
const availableAppTypes = {
  triplabot_api: true,
  tripla_booking_widget: true
}
const queryAppType = url.query.app_type
const appType = availableAppTypes[queryAppType] ? queryAppType : `triplabot`
const appTypeHeader = `${appType}/1.0`

export const triplaServer = axios.create()

triplaServer.interceptors.request.use(
  (config) => {
    const tier = getTier()
    if (tier) {
      config.headers['X-Tripla-Tier'] = tier
    }
    if (isWebView) {
      config.headers['App-Version'] ||= 'tripla/1.0'
      config.headers['Uid'] = appAccessInfo.uid
      config.headers['Access-Token'] = appAccessInfo.accessToken
    } else {
      config.headers['App-Version'] ||= appTypeHeader
      config.headers['X-Tripla-Tracing-Id'] ||= `Root=CB${PACKAGE_VERSION}-${uuid()}`
    }

    const triplabotLocale = triplaLocalStorage.getItem('triplabot_locale')
    if (triplabotLocale) {
      config.headers['Triplabot-Locale'] = triplabotLocale
    }

    // for polyglot feature
    const browserLocale = triplaLocalStorage.getItem('browser_locale')
    if (browserLocale) {
      config.headers['Browser-Locale'] = mapBrowserLocale(browserLocale)
    }

    const withAuthorizationHeader =
      config.withAuthorizationHeader !== undefined ? config.withAuthorizationHeader : true
    const session = getSession()
    if (session && withAuthorizationHeader) {
      config.headers['Authorization'] = session
    }

    return config
  },
  (error) => {
    console.error('Request interceptor error:', error)
    return Promise.reject(error)
  }
)

triplaServer.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const responseStatus = error.response?.status
    const requestURL = error.request?.responseURL || ''
    const isBRRSettingsRequest = requestURL.includes('settings/brr_widget')
    // TODO: remove this if-block when we handle sign out via pubnub
    if (responseStatus === 401 && !isBRRSettingsRequest) {
      removeSession()
      EventBus.$emit('toggle-chat')
      const chatStore = useChatStore()
      chatStore.refreshChat()
    } else if (responseStatus === 503) {
      EventBus.$emit('service-unavailable')
    }

    return Promise.reject(error)
  }
)
